import { render, staticRenderFns } from "./PerformanceChart.vue?vue&type=template&id=c55931f8&scoped=true"
import script from "./PerformanceChart.vue?vue&type=script&lang=ts"
export * from "./PerformanceChart.vue?vue&type=script&lang=ts"
import style0 from "./PerformanceChart.vue?vue&type=style&index=0&id=c55931f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55931f8",
  null
  
)

export default component.exports